var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1447 8.04642L10.2358 14.9548C10.1893 15.0015 10.1341 15.0385 10.0733 15.0637C10.0126 15.089 9.94738 15.102 9.88156 15.102C9.81574 15.102 9.75056 15.089 9.68978 15.0637C9.62899 15.0385 9.57379 15.0015 9.52734 14.9548L6.85557 12.2806C6.80912 12.2339 6.75392 12.1969 6.69313 12.1717C6.63235 12.1464 6.56717 12.1334 6.50135 12.1334C6.43553 12.1334 6.37036 12.1464 6.30957 12.1717C6.24878 12.1969 6.19358 12.2339 6.14713 12.2806C6.1005 12.327 6.06349 12.3822 6.03825 12.443C6.013 12.5038 6 12.569 6 12.6348C6 12.7006 6.013 12.7658 6.03825 12.8266C6.06349 12.8873 6.1005 12.9425 6.14713 12.989L8.8199 15.6613C9.10185 15.9427 9.48394 16.1008 9.88231 16.1008C10.2807 16.1008 10.6628 15.9427 10.9447 15.6613L17.8531 8.75436C17.8997 8.70792 17.9366 8.65275 17.9618 8.59201C17.987 8.53127 18 8.46615 18 8.40039C18 8.33463 17.987 8.26952 17.9618 8.20878C17.9366 8.14804 17.8997 8.09287 17.8531 8.04642C17.8067 7.99979 17.7515 7.96279 17.6907 7.93754C17.6299 7.91229 17.5647 7.89929 17.4989 7.89929C17.4331 7.89929 17.3679 7.91229 17.3071 7.93754C17.2463 7.96279 17.1911 7.99979 17.1447 8.04642Z",
    fill: "#769227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bda1cd6bc24f4dfd5d8455493f0ce72c.svg";
export { ForwardRef as ReactComponent };